export const responseDialogflow = (action) => {
    let next = '';
    switch(action){
        case 'BloquearCuenta':
        case 'BloquearTarjeta':
        case 'CancelarCuenta':
        case 'CancelarTarjeta':
        case 'Cuentas':
        case 'Tarjetas':
        case 'DesbloquearCuenta':
        case 'DesbloquearTarjeta':
        case 'Domicilio':
        case 'EditarDomicilio':
        case 'DatosPersonales':
        case 'EditarDatosPersonales':
        case 'InformacionApp':
        case 'InformacionCuenta':
        case 'Recomendaciones':
        case 'EnvioMovimientos':
        case 'Reemplazo':
        case 'Expediente':
        case 'Calle':
        case 'CodigoPostal':
        case 'Estado':
        case 'Municipio':
        case 'Numero':
        case 'Celular':
        case 'Email':
        case 'FechaRegistro':
        case 'FechaNacimiento':
        case 'Genero':
        case 'LugarNacimiento':
        case 'NivelRiesgo':
        case 'Ocupacion':
        case 'PerfilTransaccional':
        case 'Watchlist':
        case 'EstatusApp':
        case 'FechaInstalacion':
        case 'Sistema':
        case 'ClabeAlbo':
        case 'Estatus':
        case 'FechaApertura':
        case 'FechaEstatus':
        case 'FechaFondeo':
        case 'Productos':
        case 'ReferenciaOpen':
        case 'ReferenciaOxxo':
        case 'Error':
        case 'EditarNombre':
        case 'EditarApellidoM':
        case 'EditarApellidoP':
        case 'EditarFechaNacimiento':
        case 'EditarLugarNacimiento':
        case 'EditarGenero':
        case 'EditarOcupacion':
        case 'EditarMail':
        case 'EditarCelular':
        case 'EditarRfc':
        case 'EditarCurp':
            next = 'InfoPersonal'
            break;
        case 'EditarDomEnvio':
        case 'EditarDomFact':
        case 'EditarCp':
        case 'EditarAlcaldia':
        case 'EditarCalle':
        case 'EditarNumExt':
        case 'EditarNumInt':
        case 'EditarEstado':
        case 'EditarColonia':
            next = 'InfoPersonal'
            break;
        case 'Movimientos':
        default:
            break;
    }

    return next;
}

const deep = async (i, o, fc) => {
    if(i[fc.flist[fc.index]] === undefined) {
        return;
    }
    if( (fc.flist.length - 1) === fc.index ) {
        o[fc.flist[fc.index]] = i[fc.flist[fc.index]];
        return;
    }
    let idx = fc.index++;
    if(o.hasOwnProperty(fc.flist[idx])) {
        if(Array.isArray(o[fc.flist[idx]])) {
            if (fc.flist[fc.index] === '[*]') {
                let oa = o[fc.flist[idx]];
                let ia = i[fc.flist[idx]];
                for(let y = 0; y < ia.length; ++y) {
                    let ooa = oa[y];
                    let fca = {
                        flist : fc.flist.slice(fc.index + 1),
                        index : 0
                    }
                    await deep(ia[y], ooa ,fca);      
                }
            }
        } else if (fc.flist[fc.index] === '*') {
            let oa = o[fc.flist[idx]];
            let ia = i[fc.flist[idx]];
            for(let ox in ia) {
                let ooa = oa[ox];
                let fca = {
                    flist : fc.flist.slice(fc.index + 1),
                    index : 0
                }
                await deep(ia[ox], ooa ,fca);      
            }
        } else {
            await deep(i[fc.flist[idx]],o[fc.flist[idx]],fc)
        }
    } else {
        if(fc.flist[fc.index] === '*' && (fc.flist.length - 1) === fc.index) {
            o[fc.flist[idx]] = i[fc.flist[idx]];
        } else if (fc.flist[fc.index] === '[*]') {
            o[fc.flist[idx]] = [];
            let ia = i[fc.flist[idx]];
            for(let y = 0; y < ia.length; ++y) {
                let ooa = {};
                let fca = {
                    flist : fc.flist.slice(fc.index + 1),
                    index : 0
                }
                await deep(ia[y], ooa ,fca);      
                o[fc.flist[idx]].push(ooa);
            }
        } else if (fc.flist[fc.index] === '*') {
            o[fc.flist[idx]] = {};
            let ia = i[fc.flist[idx]];
            for(let ox in ia) {
                let ooa = {};
                let fca = {
                    flist : fc.flist.slice(fc.index + 1),
                    index : 0
                }
                await deep(ia[ox], ooa ,fca);      
                o[fc.flist[idx]][ox] = ooa; 
            }
        } else {
            o[fc.flist[idx]] = {};
            await deep(i[fc.flist[idx]],o[fc.flist[idx]],fc)
        }
    }
}

export const filter = async (data, filters) => {
    let out = {};
    if (!filters) {
        return out;
    }
    for(let i = 0; i < filters.length; ++i) {
        if( filters[i] === '*') {
            return data;
        }
        let fc = {
            flist : filters[i].split('.'),
            index : 0
        }
        await deep(data, out ,fc);      
    }
    return out;
}

const remove = async (i, fc) => {
    if(i[fc.flist[fc.index]] === undefined) {
        return;
    }
    if( (fc.flist.length - 1) === fc.index ) {
        delete i[fc.flist[fc.index]];
         return;
    }
    let idx = fc.index++;
    if(i.hasOwnProperty(fc.flist[idx])) {
        if(Array.isArray(i[fc.flist[idx]])) {
            if (fc.flist[fc.index] === '[*]') {
                let ia = i[fc.flist[idx]];
                for(let y = 0; y < ia.length; ++y) {
                    //let ooa = ia[y];
                    let fca = {
                        flist : fc.flist.slice(fc.index + 1),
                        index : 0
                    }
                    await remove(ia[y] ,fca);      
                }
            }
        } else if (fc.flist[fc.index] === '*') {
            let ia = i[fc.flist[idx]];
            for(let ox in ia) {
                let fca = {
                    flist : fc.flist.slice(fc.index + 1),
                    index : 0
                }
                await remove(ia[ox] ,fca);      
            }
        } else {
            await remove(i[fc.flist[idx]], fc)
        }
    }
}

export const exclude = async (data, filters) => {
    for(let i = 0; i < filters.length; ++i) {
        if( filters[i] === '*') {
            return {};
        }
        let fc = {
            flist : filters[i].split('.'),
            index : 0
        }
        await remove(data ,fc);      
    }
    //console.log('OUTPUT REMOVE = >' + JSON.stringify(data));
    return data;
}